//TODO: we see the use case of adding supported Events dynamically with a add/removeSupportedEvent()...
class SupportedEventEmitter {
    #_supportedEvents;
    #_listenersByEventName

    constructor(supportedEvents) {
        this.#_supportedEvents = supportedEvents;
        this.#_listenersByEventName = new Map();
    }
    /******************************************************/
    /* START EventEmitter METHOD OVERRIDES */
    /******************************************************/
    _verifyEventName(eventName) {
        if (eventName !== '*') {
            let supported = false;
            for (const supportedEvent of this.#_supportedEvents) {
                if (supportedEvent === eventName) {
                    supported = true;
                    break;
                }
                else if (supportedEvent.endsWith('*')) {
                    const supportedEventStarterString = supportedEvent.replace(/\*$/, '');
                    if (eventName.startsWith(supportedEventStarterString)) {
                        supported = true;
                        break;
                    }
                }
            }
            if (supported === false) {
                throw new Error(`Unknown EventName (${eventName}) encountered...`);
            }
        }
    }
    addListener(eventName, listener, thisContext) {
        return this.on(eventName, listener, thisContext);
    }
    listenerCount(eventName, listener) {
        this._verifyEventName(eventName);
        const listeners = this.listeners(eventName);
        if (!listener) {
            return listeners.length;
        } else {
            return listeners.filter((regListener) => regListener.origFunc === listener).length;
        }
    }
    listeners(eventName) {
        this._verifyEventName(eventName);
        let listeners = this.#_listenersByEventName.get(eventName);
        if (listeners === undefined) {
            listeners = [];
            this.#_listenersByEventName.set(eventName, listeners);
        }
        return listeners;
    }
    off(eventName, listener) {
        this._verifyEventName(eventName);
        const listeners = this.listeners(eventName);
        for (let index = listeners.length - 1; index >= 0; index--) {
            if (listeners[index].origFunc === listener) {
                listeners.splice(index, 1);
                break;
            };
        }
        if (listeners.length === 0) {
            this.#_listenersByEventName.delete(eventName);
        }
    }
    on(eventName, listener, thisContext) {
        this._verifyEventName(eventName);
        let listeners = this.listeners(eventName);
        listeners.push({ funcToBeRun: listener, origFunc: listener, thisContext });
    }
    once(eventName, listener, thisContext) {
        this._verifyEventName(eventName);
        let listeners = this.listeners(eventName);
        const onceWrappedFn = (...args) => {
            listener(...args);
            this.off(eventName, listener);
        }
        listeners.push({ funcToBeRun: onceWrappedFn, origFunc: listener, thisContext });
    }
    removeAllListeners(eventName) {
        if (eventName !== undefined) {
            this._verifyEventName(eventName);
            this.#_listenersByEventName.set(eventName, []);
        } else {
            this.#_listenersByEventName.forEach((value, key) => {
                this.#_listenersByEventName.set(key, []);
            });
        }
    }
    removeListener(eventName, listener) {
        return this.off(eventName, listener);
    }
    _getMatchingTopicName(eventName) {
        let topicName = undefined;
        for (const supportedEvent of this.#_supportedEvents) {
            if (supportedEvent.endsWith('*')) {
                const supportedEventStarterString = supportedEvent.replace(/\*$/, '');
                if (eventName.startsWith(supportedEventStarterString)) {
                    topicName = supportedEvent;
                    break;
                }
            }
        }
        return topicName;
    }
    _trigger(eventName, ...args) {
        this._verifyEventName(eventName);
        const listeners = this.listeners(eventName);
        const proms = [];
        if (listeners) {
            for (let index = listeners.length - 1; index >= 0; index--) {
                proms.push(listeners[index].funcToBeRun.call(listeners[index].thisContext, ...args));
            }
        }
        return proms;
    }
    trigger(eventName, ...args) {
        this._trigger(eventName, ...args);
        const topicEvent = this._getMatchingTopicName(eventName);
        if (topicEvent) {
            this._trigger(topicEvent, ...[eventName, ...args]);
        }
        this._trigger('*', ...[eventName, ...args]);
    }
    async triggerAndAwait(eventName, ...args) {
        const allTriggeredProms = [];
        allTriggeredProms.push(...this._trigger(eventName, ...args));
        const topicEvent = this._getMatchingTopicName(eventName);
        if (topicEvent) {
            allTriggeredProms.push(...this._trigger(topicEvent, ...[eventName, ...args]));
        }
        allTriggeredProms.push(...this._trigger('*', ...[eventName, ...args]));
        await Promise.all(allTriggeredProms);
    }
    /******************************************************/
    /* END EventEmitter METHOD OVERRIDES */
    /******************************************************/
}
export { SupportedEventEmitter };
export default SupportedEventEmitter;